// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meResume[data-v-4136c27c] {\n  height: 100%;\n  background: #f5f6f8;\n  padding: 0.260417rem 0.078125rem 0.260417rem 0.229167rem;\n}\n.meResume .img[data-v-4136c27c] {\n  width: 2.604167rem;\n  height: 0.875rem;\n  margin-right: 0.192708rem;\n}", ""]);
// Exports
module.exports = exports;
